import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
// ✅ CHANGED: GridOptions + IServerSideGetRowsParams → IDatasource, IGetRowsParams (infinite row model, not server-side)
// ✅ REMOVED: GridOptions import — typed as 'any' to avoid version mismatch
import { IDatasource, IGetRowsParams } from 'ag-grid-community';
import { ServerRequest } from 'src/app/_models/global.data.model';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { TableHeaderToolTipComponent } from '../../table-header-tool-tip/table-header-tool-tip.component';
import { PriceRateCardBookService } from 'src/app/_services/price-rate-card-book.service';
import moment from 'moment';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';

@Component({
  selector: 'app-custella-rate-cards',
  templateUrl: './custella-rate-cards.component.html',
  styleUrls: ['./custella-rate-cards.component.scss'],
  standalone: false,
})
export class CustellaRateCardsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();

  @Input() data: any;
  @Input() view: any;
  @Input() url: any;

  gridApi: any;
  // ✅ REMOVED: gridColumnApi — deleted in AG Grid v35
  columnDefs: any;
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  // ✅ CHANGED: GridOptions → any (GridOptions removed from ag-grid-community in v35)
  gridOptions: any;
  overlayNoRowsTemplate: any;
  productsFamilies: any;
  productsType: any;
  currentRecordNumber: any;
  totalRecord: any;

  searchValue: any = null;
  checklistData: any;
  translate: any;

  constructor(
    private priceRateCardBookService: PriceRateCardBookService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private util: UtilServiceService,
    private ngZone: NgZone, // ✅ ADDED: prevents ExpressionChangedAfterItHasBeenCheckedError
  ) {
    super();

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => { params.api.sizeColumnsToFit(); },
      tooltipShowDelay: 100,
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  ngOnInit(): void {
    console.log(this.url, "====", this.view, "----", this.data);
    this.getLanguageData();
  }

  ngOnDestroy(): void { super.ngOnDestroy(); }

  public viewCell($event: any) {
    const field = $event.colDef.field;
    console.log(field);
    if (field === "name") { this.selectItem($event.data); }
  }

  selectItem(val: any) { this.itemSelector.emit(val); }

  public closeTable() { this.closeView.emit(false); }

  push(obs: any) { super.push(obs); }

  /********************************** Search **************************/
  onSearchCheck() { this.onGridReady(this.gridParams); }

  /********************************** On Grid Ready **************************/
  onGridReady(params: any) {
    this.gridParams = params;
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    // ✅ CHANGED: IDatasource + IGetRowsParams (was IServerSideGetRowsParams — wrong model type)
    // ✅ CHANGED: setDatasource() → setGridOption("datasource", ...) — setDatasource removed in v35
    const dataSource: IDatasource = {
      getRows: (params: IGetRowsParams) => {
        this.getServerSideData(params);
      },
    };

    this.gridApi.sizeColumnsToFit();
    this.gridApi.setGridOption("datasource", dataSource);
  }

  /********************************** Get Server Side Data **************************/
  // ✅ CHANGED: IGetRowsParams (was IServerSideGetRowsParams)
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);
    console.log('Making a server request: ', serverRequest);

    var customerId = null;
    var installationDate = null;

    if (this.view == 'jo') {
      customerId = this.data?.customer?.id ? this.data?.customer?.id : null;
      installationDate = this.data?.installationDate ? this.data?.installationDate : null;

      if (this.data.installationDate) {
        installationDate = this.util.timeFormatter(
          moment(this.data.installationDate, "h:mm A").format("h:mm A"),
          moment(this.data.installationDate, "YYYY-MM-DD").format("YYYY-MM-DD")
        ).toISOString();
      }
    }

    if (this.view == 'task') {
      customerId = this.data?.customer ? this.data?.customer : null;
      installationDate = null;
    }

    console.log("customerId", customerId, "installationDate", installationDate);

    this.push(
      this.priceRateCardBookService.getActiveRateCardList(
        this.url, this.searchValue, serverRequest, customerId, installationDate
      ).subscribe(
        (data: any) => {
          console.log(data.body);
          this.checklistData = data.body.data;
          this.totalRecord = data.body.total;
          this.setGridData(agGridGetRowsParams, this.checklistData, data.body.total, data.body.status);
        },
        (err) => { this.errorUtil.setErrorMessage(err); }
      )
    );
  }

  /********************************** Set Grid Data **************************/
  // ✅ CHANGED: IGetRowsParams (was IServerSideGetRowsParams)
  // ✅ NOTE: successCallback() was already used correctly here
  // ✅ ADDED: ngZone.run() — prevents ExpressionChangedAfterItHasBeenCheckedError
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    console.log(resultItems, "===");
    this.ngZone.run(() => {
      if (this.checklistData.length === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        agGridGetRowsParams.successCallback(this.checklistData, totalCount);
      }
    });
  }

  /********************************** Request Params **************************/
  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "name", sort: "asc" };
      agGridRequest.sortModel.push(this.parameters);
    }
    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** Language **************************/
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe(data => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.initializeColumns();
        }
      })
    );
    console.log("translate", this.translate);
  }

  /********************************** Initialize Columns **************************/
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate = "<div class='not-found'><span>" + this.translate?.general.messages.noRecordsFound + "</span> </div>";

    const newData = [
      {
        headerName: this.translate?.rateCard.fields.rateCardName.singular,
        field: 'name',
        width: 170,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation" id="Tbl_HeadContraRateCardName">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>',
        },
        cellRenderer: function (params: any) {
          if (params.data) {
            return '<p id="' + params.data.rowId + '">' + params.data.name + '</p>';
          }
        },
        cellClass: function (params: any) { return ['table_default_color-top']; },
        headerTooltip: "#",
      },
      {
        headerName: this.translate?.rateCard.fields.status.singular,
        field: 'status',
        width: 170,
        headerTooltip: "#",
        cellRenderer: (params: any) => {
          if (params.data) {
            if (params.data.status == 'ACTIVE') {
              return '<span class="p-mr-2  p-tag p-component p-tag-success" ><span class="p-tag-value">' + this.translate.general.status.active.singular + '</span></span>';
            } else {
              return '<span class="p-mr-2  p-tag p-component p-tag-danger" ><span class="p-tag-value text-dark">' + this.translate.general.status.inactive.singular + '</span></span>';
            }
          }
        },
      },
    ];

    this.columnDefs = newData;
    if (this.gridApi) {
      // ✅ CHANGED: setColumnDefs() removed in v35 → setGridOption("columnDefs", ...)
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 500);
    }
  }
}